import { AudioFragment } from './chunk-IQYQ7RE4.mjs';
import { getFragmentData } from './chunk-KTM5ANUO.mjs';

// src/listen/query-hooks/transformers.ts
var transformAudioFragment = (audioData) => {
  const audio = getFragmentData(AudioFragment, audioData);
  return {
    id: audio.id,
    name: audio.name,
    source: audio.source,
    thumbnailUrl: audio.thumbnailUrl || "",
    artistName: audio.artistName
  };
};

export { transformAudioFragment };
//# sourceMappingURL=chunk-DEH3IUAL.mjs.map
//# sourceMappingURL=chunk-DEH3IUAL.mjs.map